export default {
  home: '首頁',
  my_accout: '我的賬戶',
  account_info: '賬戶信息',
  bonds: '買賣債務申請',
  otherAccount: '交易賬戶申請',
  records: '資金記錄',
  setting: '設置',
  deposit: '存款',
  subAccount: '子賬戶申請',
  tradeProduct: '交易結構性產品申請',
  withdrawal: '取款',
  internal_transfer: '內部轉賬',
  download: '平台下載',
  trade_recordes: '交易記錄',
  open_trades: '開放交易',
  close_trades: '關閉交易',
  logout: '退出登錄',
  'table-download': '文件下載',
  exchange: '換匯',
  quotes: '實時行情服務申請'
}
